const initialState = {
  sidepanelStatus: window.localStorage.getItem(`sidepanelStatus`) || 'default',
  isSidePanelCollapsed: window.localStorage.getItem(`sidepanelStatus`)
    ? window.localStorage.getItem(`sidepanelStatus`) === 'icon-only'
    : false,
};

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case 'COMMON_UPDATE_SIDEPANEL_STATUS': {
      if (action.status !== 'overlay') {
        window.localStorage.setItem(`sidepanelStatus`, action.status);
      }

      return {
        ...state,
        sidepanelStatus: action.status,
        isSidePanelCollapsed: action.status === 'icon-only',
      };
    }

    default:
      return state;
  }
}
